import { useDispatch } from "react-redux";
import {
    selectAllRecords,
  selectPage,
  unSelectAll,
  useSelectAllSelected,
  useSelectSelected,
  useSelectSelectionMode,
} from "../../../../redux/features/reports/singleClientReportSlice";
import IconChevronDown from "@tabler/icons-react/dist/esm/icons/IconChevronDown.mjs";
import IconDeselect from "@tabler/icons-react/dist/esm/icons/IconDeselect.mjs";
import { ActionIcon, Badge, Box, Checkbox, Group, Menu } from "@mantine/core";
import classes from "./singleClientReportTable.module.scss";


const HeaderSelectionControl = ({ pageIds, totalCount }) => {
  const allSelected = useSelectAllSelected();
  const selected = useSelectSelected();
  const selectionMode = useSelectSelectionMode();
  const dispatch = useDispatch();

  const pageIdSet = new Set(pageIds);
  const pageSelectedCount = selected.filter((id) => pageIdSet.has(id)).length;
  const allPageSelected =
    pageIds.length > 0 && pageSelectedCount === pageIds.length;
  const somePageSelected = pageSelectedCount > 0 && !allPageSelected;

  const isChecked = allSelected || allPageSelected;
  const isIndeterminate = !allSelected && somePageSelected;

  let selectedCount = 0;
  if (selectionMode === "all") {
    selectedCount = totalCount;
  } else {
    selectedCount = selected.length;
  }

  const handleCheckboxToggle = () => {
    if (isChecked || isIndeterminate) {
      dispatch(unSelectAll());
    } else {
      dispatch(selectPage(pageIds));
    }
  };

  return (
    <Box
      style={{
        display: "flex",
      }}
    >
      <Group gap={2} wrap="nowrap" justify="center">
        <Checkbox
          checked={isChecked}
          indeterminate={isIndeterminate}
          onChange={handleCheckboxToggle}
          aria-label="Select rows"
          styles={{
            input: { cursor: "pointer" },
          }}
        />
        <Menu
          shadow="sm"
          width={220}
          position="bottom-start"
          withArrow
          arrowPosition="center"
        >
          <Menu.Target>
            <ActionIcon
              variant="subtle"
              color="gray"
              size="xs"
              aria-label="Selection options"
            >
              <IconChevronDown size={14} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Label>Select Rows</Menu.Label>
            <Menu.Item onClick={() => dispatch(selectPage(pageIds))}>
              All on this page ({pageIds.length})
            </Menu.Item>
            <Menu.Item onClick={() => dispatch(selectAllRecords())}>
              All records ({totalCount})
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item
              leftSection={<IconDeselect size={16} />}
              onClick={() => dispatch(unSelectAll())}
              color="red"
            >
              Clear selection
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>

      <Box>
        {selectedCount > 0 && (
          <Badge
            size="md"
            variant="light"
            color="secondary.9"
            className={classes["selection-badge"]}
          >
            {selectedCount}
          </Badge>
        )}
      </Box>
    </Box>
  );
};

export default HeaderSelectionControl;
